<form class="form-vertical" id="editunicatform" data-hook="editunicatform">
  <div class="row">
    <div class="form-group col-xs-12 col-md-6">
      <label for="xxx">xxx</label>
      
    </div>
    <div class="form-group col-xs-12 col-md-6">
      <label for="yyy">xxx</label>
     
    </div>
  </div>
  
  <div class=" row">
    <div class="col-xs-12">
      <div class="form-group">
        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</form>